import axios from "axios";

export const API_URL = __IS_DEV__ ? "/api" : `${__API_URL__}/api`;

const $api = axios.create({
  withCredentials: true,
  baseURL: API_URL,
});

export default $api;
